import { Link } from 'react-router-dom';

import { useBillingStatus } from '../hooks/useBilling.js';

export function TrialNotice() {
  const { data } = useBillingStatus();
  if (!data?.billingEnabled || data.entitlement !== 'trialing') {
    return null;
  }
  const dayLabel = data.daysRemaining === 1 ? 'day' : 'days';

  return (
    <div className="billing-trial-notice" role="status">
      <span>
        <strong>{data.daysRemaining}</strong> {dayLabel} left in your free trial
      </span>
      <Link to="/subscribe">Subscribe now</Link>
    </div>
  );
}
